import Timescale from './Timescale'
import Tracks from './Tracks'
import PlayHead from './PlayHead'
import * as Styled from './styled'
import { TIMELINE_CONTENT_WRAPPER_ID } from './consts'
import { useReactSelectoHandlers } from './Tracks/hooks/use-react-selecto-handlers'
import { ReactSelecto } from 'common-components'
import { useTimelineContext } from 'context/TimelineContext'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { useDeselectTimelineItems } from './hooks'
import MagnetizingLine from 'components/MagnetizingLine'
import { useElementSize } from 'hooks/useElementSize'
import { useRef } from 'react'

const MainContainer: React.FC = () => {
  const contentWrapperRef = useRef<HTMLDivElement>(null)
  const { onAdd, onRemove, selectoRef } = useReactSelectoHandlers()
  const { scrollableContainerRef } = useTimelineContext()
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  useDeselectTimelineItems()
  const { height: mainContainerHeight } = useElementSize(scrollableContainerRef)

  return (
    <Styled.MainContainer
      onScroll={() => {
        selectoRef.current?.checkScroll()
      }}
      ref={scrollableContainerRef}
    >
      <Styled.ContentWrapper
        id={TIMELINE_CONTENT_WRAPPER_ID}
        ref={contentWrapperRef}
      >
        <Styled.StickyContainer>
          <Timescale />
          <PlayHead height={mainContainerHeight} />
        </Styled.StickyContainer>

        <MagnetizingLine />
        <Tracks />
      </Styled.ContentWrapper>

      {!isMobile && (
        <ReactSelecto
          scrollableContainerRef={scrollableContainerRef.current}
          onAdd={onAdd}
          onRemove={onRemove}
          selectoRef={selectoRef}
          boundContainerRef={contentWrapperRef}
        />
      )}
    </Styled.MainContainer>
  )
}

export default MainContainer
